import { render, staticRenderFns } from "./audit-modal.vue?vue&type=template&id=63b4f3ae&scoped=true&"
import script from "./audit-modal.vue?vue&type=script&lang=js&"
export * from "./audit-modal.vue?vue&type=script&lang=js&"
import style0 from "./audit-modal.vue?vue&type=style&index=0&id=63b4f3ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b4f3ae",
  null
  
)

export default component.exports